module.exports = __webpack_public_path__ + "static/media/camera-icon.8200c6c3.svg";